import React, { useState } from 'react'
import { observer } from 'mobx-react-lite'

import { MsStoresLoadingProps } from '../StoreReturnsSettings'
import { StoreSuppliesSettings, SuppliesFormData } from '../StoreSuppliesSettings'

import { useApi } from '../../../hooks/storeHook'

import { YmAccountProps } from '../../../types/accountProps'
import { SupplyShipmentStatus } from '../../../server/mpsklad_core/Entity/Enums/SupplyShipmentStatus'

export type YandexMarketSuppliesSettingsProps =
  YmAccountProps & MsStoresLoadingProps

export const YandexMarketSuppliesSettings =
  observer(
    ({account, msStores, loadMsStores}: YandexMarketSuppliesSettingsProps) => {
      const [selectedStatus, setSelectedStatus] = useState<SupplyShipmentStatus>(
        account.autoCreateMoveDocsInMoySkladOnShipmentStatus)

      const api = useApi()

      const onSubmit =
        async ({autoCreateMoveDocsInMoySklad, supplyMoveSourceStoreId, supplyMoveTargetStoreId}: SuppliesFormData) => {
          await api.userSync.setYandexMarketSuppliesSettings({
            accountId: account.id,
            autoCreateMoveDocsInMoySkladOnShipmentStatus: selectedStatus,
            autoCreateMoveDocsInMoySklad,
            supplyMoveSourceStoreId,
            supplyMoveTargetStoreId
          })
        }

      return (
        <StoreSuppliesSettings
          account={account}
          msStores={msStores}
          loadMsStores={loadMsStores}
          deliveryTypeHint="FBY"
          autoMoveHint="по поставкам Yandex.Market"
          isAllowed={account.allowOptionAutoCreateMoveDocsInMoySklad}
          selectedStatus={selectedStatus}
          setSelectedStatus={setSelectedStatus}
          onSubmit={onSubmit}
        />
      )
    })